import http from '../interceptors/Intercepter';

export const retrieveStudies = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/study/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createStudy = async (username, studyVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/study/create', studyVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewStudy = async (username, facilityExternalReference, studyExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
      facilityExternalReference: facilityExternalReference,
      studyExternalReference: studyExternalReference,
    };

    const { data } = await http.get('/api/study/view', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateStudy = async (username, studyVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.put('/api/study/update', studyVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateStudyAddSite = async (username, addStudyToSiteVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.put('/api/study/update/study/add-site', addStudyToSiteVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteStudy = async (username, facilityExternalReference, studyExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
      facilityExternalReference: facilityExternalReference,
      studyExternalReference: studyExternalReference,
    };

    const { data } = await http.delete('/api/study/delete', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveStudyDropdowns = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/study/viewAll/dropdown', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const validateStudyProtocolID = async (username, protocolID) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      protocolID: protocolID,
      username: username,
    };

    const { data } = await http.get('/api/study/view/protocol-id', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveStudyDropdownsSpecific = async (username, onlyActive = false) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = { username, onlyActive };

    const { data } = await http.get('/api/study/viewAll/dropdown/user-specific', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveStudyDropdownsAltFormat = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = { username };

    const { data } = await http.get('/api/study/viewAll/dropdown/alternate-format', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveStudySchedulesDropdowns = async (studyExternalReference, username, enrollmentScheduleOnly) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      studyExternalReference: studyExternalReference,
      username: username,
      enrollmentScheduleOnly: enrollmentScheduleOnly,
    };

    const { data } = await http.get('/api/study-schedule/view/dropdown', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveStudySchedulesForParticipantDropdowns = async (
  participantExternalReference,
  studyExternalReference,
  username
) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      participantExternalReference: participantExternalReference,
      studyExternalReference: studyExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/study-schedule/view/dropdown/participant', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
